import Button from '@mui/material/Button';
import Grid from '@mui/system/Unstable_Grid/Grid';
import NewComponentService from '../../../services/NewComponentService';
import React from 'react';
import { TimelineComponent } from '../../../models/LessonComponent';
import TimelineItems from './TimelineItems';
import TimelineView from './TimelineView';
import { cloneDeep } from 'lodash';
import { useLessonContext } from '../../../models/LessonContext';
import { useLessonEditContext } from '../../../models/LessonEditContext';
import useThemes from '../../../../shared/hooks/useThemes';

export interface TimelineProps {
  component: TimelineComponent;
}

export default function Timeline(props: TimelineProps) {
  const { handleSettingsChange } = useLessonEditContext();
  const { mode } = useLessonContext();
  const { muiTheme } = useThemes();
  const fontFamily = muiTheme.typography.fontFamily;

  const handleAdd = () => {
    const newItem = NewComponentService.createTimelineItem();
    const copy = cloneDeep(props.component);
    copy.content.timeline.push(newItem);
    handleSettingsChange(copy);
  };

  return (
    <div style={{ fontFamily, overflowWrap: 'anywhere' }}>
      {mode === 'edit' ? (
        <Grid container direction="column">
          <Grid sx={{ width: '100%' }}>
            <TimelineItems component={props.component} />
          </Grid>
          <Grid>
            <Button onClick={handleAdd}>Add Item</Button>
          </Grid>
        </Grid>
      ) : (
        <TimelineView component={props.component} />
      )}
    </div>
  );
}
